/** #@condition: genbet **/
/** Only for genbet **/
import {AbstractVisualFeature} from '../../../visual-feature.js';
import {EventPage} from '../event-page.js';

import {marketInstructionsFactory} from './market-instructions.factory';

import PALETTE_SCHEMA from './market-instructions.palette-schema.yaml';

class MarketInstructionsFeature extends AbstractVisualFeature {
    get name() {
        return 'MarketInstructions';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return marketInstructionsFactory(PALETTE);
    }
}

new MarketInstructionsFeature(EventPage);
